<template>
    <div>
        <hua-nav-bar
            :title="'审批管理'"
            left-arrow
            @click-left="onClickLeft"
            style="margin-bottom: 10px"
        ></hua-nav-bar>
        <!-- 只展示待审核和访客列表 -->
        <hua-tabs v-model="active" @click="changeTab">
            <hua-tab :title="item" v-for="(item, index) in tabs1" :key="index"></hua-tab>
            <!-- v-if="active == 0 || active == 1" -->
            <wait-audit
                ref="wait"
                :v_personid="v_personid"
                :userId="userId"
                :active="active"
            ></wait-audit>
        </hua-tabs>
    </div>
</template>

<script>
import waitAudit from '@/view/myVisitorList/components/waitAudit.vue'
import api from '@/constants/api'
export default {
    components: {
        waitAudit,
    },
    data() {
        return {
            active: 0,
            u_phone: null,
            u_name: null,
            v_personid: null, //h5
            userId: null, // APP
            tabs1:['待审核', '在访', '离访', '已取消', '预约成功'],
            // 判断当前页面是不是直接从企业号(logEnterprise)或公众号(log)跳转过来的
            logJumpVisitorList:false,
            jobNum:null
        }
    },
    methods: {
        onClickLeft() {
            let logLastPageVisitor = localStorage.getItem('logLastPageVisitor')
            let lastPageVisitor = localStorage.getItem('lastPageVisitor')
            let accountCode = ''
            let accountState = ''
            if (localStorage.getItem("accountCode")) {
                accountCode = JSON.parse(localStorage.getItem("accountCode"))
                accountState = JSON.parse(localStorage.getItem("accountState"))
            }
            if (window.navigator.userAgent.indexOf('dhb') !== -1) {
                window.addEventListener('dhbready', async () => {
                    let plugin = await DhbPlugin('dhb/plugin/messagehandle')
                    if (plugin) {
                        plugin.callHandler('finish', 'para', (message) => {
                            console.log(1)
                        })
                    }
                })
            } else if (lastPageVisitor === 'log' || logLastPageVisitor === 'log') {
                // this.$router.push({ path: `/log?phone=${u_phone}` })
                this.$router.push({ path: `/log?code=${accountCode}&state=${accountState}` })
            } else if (lastPageVisitor === 'logEnterprise' || logLastPageVisitor === 'logEnterprise') {
                this.$router.push({ path: `/logEnterprise?personCode=${this.jobNum}` })
            } else {
                this.$router.push({ name: 'index' })
            }
            // localStorage.removeItem('v_personid')
        },
        changeTab(name) {
            // name===0待审核，1在访，2离访，3已取消，4预约成功
            // 后端接口入参status对应===0待审核，2在访，3离访，4已取消，1预约成功
            console.log('namenamename', name);
            this.u_name = sessionStorage.getItem('u_name')
            this.u_phone = localStorage.getItem('u_phone')
            // 等待子组件中active改变后再刷新数据
            this.$refs.wait.waitData = []
            setTimeout(() => {
                this.$refs.wait.getReviewList(this.v_personid, true)
            }, 20)
        },
    },
    mounted() {
      this.logJumpVisitorList = JSON.parse(localStorage.getItem('logJumpVisitorList'))
      this.active = Number(localStorage.getItem('myVisitorListActive'));
      this.jobNum = sessionStorage.getItem('u_jobNumber');
      if(this.jobNum) {
        // this.jobNum = typeof this.jobNum === 'string' ? JSON.parse(this.jobNum) : this.jobNum
      }
        // console.log(localStorage.getItem('v_personid'),"v_personid=============审核======")
        if(!localStorage.getItem('v_personid')) {
           this.$router.push({name: 'index'});
           this.v_personid = localStorage.getItem('v_personid')
        } else {
            this.v_personid = JSON.parse(localStorage.getItem('v_personid')) //h5登录时存的
            this.v_personid = this.v_personid.toString();
        }
        this.userId = localStorage.getItem('userId') //APP登录时存的
        const fromH5 = localStorage.getItem('fromH5');
        if (!fromH5 && this.userId) {
          api.checkPersonIdByuserId(this.userId)
                .then((res) => {
                    this.u_phone = res.data.phone
                    this.u_name = res.data.name
                    this.v_personid = res.data.personId
                    localStorage.setItem('u_phone', JSON.stringify(this.u_phone))
                    sessionStorage.setItem('u_name', this.u_name)
                    localStorage.setItem('v_personid', JSON.stringify(this.v_personid))
                    if (this.$route.params.active) {
                        let active = this.$route.params.active
                        this.active = active === 'detail' ? 1 : active === 2 ? 2 : 0
                    }
                    if (this.active !== 2) {
                        console.log('1233333=====wsy');
                        this.$refs.wait.getReviewList(this.v_personid, true)
                    }
                    this.$router.push({
                        path: `/approvalManage/${this.v_personid}`,
                    })
                })
                .catch((err) => {
                    localStorage.removeItem('u_phone')
                    sessionStorage.removeItem('u_name')
                    this.$toast(JSON.stringify(err.errMsg));
                })
        } else {
            if (this.$route.params.active) {
                let active = this.$route.params.active
                this.active = active === 'detail' ? 1 : active === 2 ? 2 : 0
            }
            if (this.active !== 2) {
                console.log('44444444=====wsy');
                this.$refs.wait.getReviewList(this.v_personid, true)
            }
            this.$router.push({
                path: `/approvalManage/${this.v_personid}`,
            })
        }
    },
     // 判断当前页面是从哪个页面跳转过来的
    beforeRouteEnter (to, from, next) {
        localStorage.setItem('lastPageVisitor', from.name)
        if(from.name === 'log' || from.name === 'logEnterprise') {
            localStorage.setItem('logLastPageVisitor', from.name)
        }
        if(from.name === 'log' || from.name === 'logEnterprise' || from.name ==='approvaSingleLogin') { // 当前是从访客管理导航页面页面跳过来的(公众号(log)或企业号(logEnterprise))
            localStorage.setItem('logJumpVisitorList', JSON.stringify(true))
        }else {
            localStorage.setItem('logJumpVisitorList', JSON.stringify(false))
        }
        next()
    }
}
</script>
